"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cyclingProfiles = void 0;
var _react = _interopRequireDefault(require("react"));
var _daily = require("../components/icons/profiles/daily");
var _direct = require("../components/icons/profiles/direct");
var _safe = require("../components/icons/profiles/safe");
var _touristic = require("../components/icons/profiles/touristic");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const cyclingProfiles = exports.cyclingProfiles = {
  safe: {
    labelKey: 'commons.profiles.safe',
    longLabelKey: 'commons.profiles.safe_long',
    descriptionKey: 'commons.profiles.safe_description',
    icon: /*#__PURE__*/_react.default.createElement(_safe.SafeProfileIcon, {
      color: "inherit"
    })
  },
  daily: {
    labelKey: 'commons.profiles.daily',
    longLabelKey: 'commons.profiles.daily_long',
    descriptionKey: 'commons.profiles.daily_description',
    icon: /*#__PURE__*/_react.default.createElement(_daily.DailyProfileIcon, {
      color: "inherit"
    })
  },
  direct: {
    labelKey: 'commons.profiles.direct',
    longLabelKey: 'commons.profiles.direct_long',
    descriptionKey: 'commons.profiles.direct_description',
    icon: /*#__PURE__*/_react.default.createElement(_direct.DirectProfileIcon, {
      color: "inherit"
    })
  },
  touristic: {
    labelKey: 'commons.profiles.touristic',
    longLabelKey: 'commons.profiles.touristic_long',
    descriptionKey: 'commons.profiles.touristic_description',
    icon: /*#__PURE__*/_react.default.createElement(_touristic.TouristicProfileIcon, {
      color: "inherit"
    })
  },
  hybridBike: {
    labelKey: 'commons.profiles.hybrid_bike',
    longLabelKey: 'commons.profiles.hybrid_bike_long',
    descriptionKey: 'commons.profiles.hybrid_bike_description'
  },
  cargo: {
    labelKey: 'commons.profiles.cargo',
    longLabelKey: 'commons.profiles.cargo_long',
    descriptionKey: 'commons.profiles.cargo_description'
  }
};